"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminDashboard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var site_editor_1 = require("../../components/admin/site-editor");
var site_list_1 = require("../../components/admin/site-list");
var sites_1 = require("../../features/apis/sites");
var hooks_1 = require("../../store/hooks");
var AdminDashboard = function () {
    var _a = (0, react_1.useState)(null), selectedSite = _a[0], setSelectedSite = _a[1];
    var _b = (0, react_1.useState)(false), isEditing = _b[0], setIsEditing = _b[1];
    // Get user profile to check admin status
    var userProfile = (0, hooks_1.useAppSelector)(function (state) { return state.userProfile.profile; });
    var userPermissions = (userProfile === null || userProfile === void 0 ? void 0 : userProfile.permissions) || {};
    var canCreateSites = userProfile === null || userProfile === void 0 ? void 0 : userProfile.isAdmin;
    var canEditDomains = userProfile === null || userProfile === void 0 ? void 0 : userProfile.isAdmin;
    var canEditProviders = Boolean(userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.edit_providers) ||
        Boolean(userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.admin) ||
        Boolean(userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.super_admin);
    var canViewProviders = canEditProviders || Boolean(userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.view_providers);
    // RTK Query hooks for API
    var _c = (0, sites_1.useGetAllSitesQuery)(), sitesResponse = _c.data, apiError = _c.error, isLoading = _c.isLoading, refetch = _c.refetch;
    var createSite = (0, sites_1.useCreateSiteMutation)()[0];
    var updateSite = (0, sites_1.useUpdateSiteMutation)()[0];
    var deleteSite = (0, sites_1.useDeleteSiteMutation)()[0];
    // Get sites from MongoDB
    var sites = [];
    if ((sitesResponse === null || sitesResponse === void 0 ? void 0 : sitesResponse.success) && sitesResponse.content) {
        sites = sitesResponse.content.sites;
    }
    else if (apiError) {
        console.error("Failed to load sites from MongoDB:", apiError);
    }
    var handleEditSite = function (site) {
        setSelectedSite(site);
        setIsEditing(true);
    };
    var handleCreateSite = function () {
        var newSite = {
            name: "New Site",
            slug: "", // URL-friendly slug (e.g., "janeel", "pioneer") - lowercase letters, numbers, hyphens only
            domains: [], // Custom production domains
            providerId: "", // Admin will assign Firebase provider ID manually
            defaultSite: false,
            contact: {
                email: "info@example.com",
                phone: "+1 234 567 8900",
                address: "123 Business Street, City, State 12345",
            },
            branding: {
                logo: "",
                primaryColor: "#ca2128",
                secondaryColor: "#1E40AF",
                accentColor: "#F59E0B",
            },
            navigation: {
                items: [{ label: "Home", href: "#hero", active: true }],
            },
            heroSlides: [
                {
                    id: "slide-1",
                    title: "Welcome to Our Business",
                    subtitle: "Your success is our mission",
                    backgroundImage: "",
                    ctaButton: {
                        text: "Get Started",
                        href: "/contact",
                    },
                    order: 1,
                },
            ],
            sections: [],
            footer: {
                copyright: "© 2024 Your Company Name. All rights reserved.",
                links: [
                    { label: "Privacy Policy", href: "/privacy" },
                    { label: "Terms of Service", href: "/terms" },
                ],
            },
        };
        setSelectedSite(newSite);
        setIsEditing(true);
    };
    /**
     * Helper function to extract and format validation errors from API response
     */
    var formatValidationErrors = function (error) {
        var _a, _b, _c, _d, _e, _f;
        // Check if we have validation errors in the expected structure
        var validationErrors = ((_b = (_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.errors) || ((_c = error === null || error === void 0 ? void 0 : error.data) === null || _c === void 0 ? void 0 : _c.errors);
        if (validationErrors && Array.isArray(validationErrors)) {
            // Format each validation error
            var errorMessages = validationErrors.map(function (err) {
                var fieldName = err.key || err.field || "Unknown field";
                var message = err.message || "Invalid value";
                return "\u2022 ".concat(fieldName, ": ").concat(message);
            });
            return ("Validation errors:\n\n" +
                errorMessages.join("\n") +
                "\n\nPlease fix these issues and try again.");
        }
        // Check for other error message formats
        var errorMessage = ((_e = (_d = error === null || error === void 0 ? void 0 : error.data) === null || _d === void 0 ? void 0 : _d.content) === null || _e === void 0 ? void 0 : _e.message) ||
            ((_f = error === null || error === void 0 ? void 0 : error.data) === null || _f === void 0 ? void 0 : _f.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Unknown error occurred";
        return errorMessage;
    };
    var handleSaveSite = function (site) { return __awaiter(void 0, void 0, void 0, function () {
        var existingIndex, response, error_1, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    existingIndex = sites.findIndex(function (s) { return s._id === site._id; });
                    response = void 0;
                    if (!(site._id && existingIndex >= 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateSite({
                            siteId: site._id,
                            siteConfig: site,
                        }).unwrap()];
                case 1:
                    // Update existing site
                    response = _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, createSite(site).unwrap()];
                case 3:
                    // Create new site
                    response = _a.sent();
                    _a.label = 4;
                case 4:
                    if (response.success) {
                        setIsEditing(false);
                        setSelectedSite(null);
                    }
                    else {
                        alert("Error saving site: " + (response.message || "Unknown error"));
                    }
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    console.error("Error saving site:", error_1);
                    errorMessage = formatValidationErrors(error_1);
                    alert(errorMessage);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteSite = function (siteId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2, errorMessage;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!confirm("Are you sure you want to delete this site?")) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteSite(siteId).unwrap()];
                case 2:
                    response = _b.sent();
                    if (!response.success) {
                        alert("Error deleting site: " + (response.message || "Unknown error"));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _b.sent();
                    console.error("Error deleting site:", error_2);
                    errorMessage = ((_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.data) === null || _a === void 0 ? void 0 : _a.message) || "Unknown error";
                    alert("Error deleting site: " + errorMessage);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    if (isLoading) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "flex items-center justify-center py-32", children: (0, jsx_runtime_1.jsxs)("div", { className: "text-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500 mx-auto" }), (0, jsx_runtime_1.jsx)("p", { className: "mt-4 text-gray-600", children: "Loading sites..." })] }) }));
    }
    if (isEditing && selectedSite) {
        return ((0, jsx_runtime_1.jsx)(site_editor_1.SiteEditor, { site: selectedSite, onSave: handleSaveSite, onCancel: function () {
                setIsEditing(false);
                setSelectedSite(null);
            }, existingSites: sites, canEditProviders: canEditProviders, canViewProviders: canViewProviders, canEditDomains: !!canEditDomains }));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between mb-8", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-3xl font-bold text-gray-900", children: "Site Manager" }), (0, jsx_runtime_1.jsx)("p", { className: "mt-2 text-gray-600", children: "Manage all your website configurations" })] }), canCreateSites && ((0, jsx_runtime_1.jsxs)("button", { onClick: handleCreateSite, className: "px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center", children: [(0, jsx_runtime_1.jsx)("svg", { className: "w-5 h-5 mr-2", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 4v16m8-8H4" }) }), "Create New Site"] }))] }), (0, jsx_runtime_1.jsx)(site_list_1.SiteList, { sites: sites, onEdit: handleEditSite, onDelete: handleDeleteSite, onPreview: function (site) {
                    // Prefer slug over ID for cleaner URLs
                    var urlParam = site.slug && site.slug.trim() !== "" ? site.slug : site._id;
                    if (!urlParam)
                        return;
                    var previewUrl = "/site/".concat(urlParam);
                    window.open(previewUrl, "_blank", "noopener,noreferrer");
                }, loading: isLoading }), sites.length === 0 && !isLoading && ((0, jsx_runtime_1.jsxs)("div", { className: "text-center py-12", children: [canCreateSites && ((0, jsx_runtime_1.jsx)("button", { onClick: handleCreateSite, className: "px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700", children: "Create Your First Site" })), (0, jsx_runtime_1.jsx)("p", { className: "text-gray-500", children: "No sites available." })] }))] }));
};
exports.AdminDashboard = AdminDashboard;
